import { render, staticRenderFns } from "./BulkModifiersSelector.vue?vue&type=template&id=649d346e&scoped=true"
import script from "./BulkModifiersSelector.vue?vue&type=script&lang=js"
export * from "./BulkModifiersSelector.vue?vue&type=script&lang=js"
import style0 from "./BulkModifiersSelector.vue?vue&type=style&index=0&id=649d346e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d346e",
  null
  
)

export default component.exports